import {
  REQUEST_CONTROL_POINTS,
  RESPONSE_CONTROL_POINTS,
  REQUEST_CONTROL_POINTS_FAILURE,
  REQUEST_CREATE_CONTROL_POINT,
  RESPONSE_CREATE_CONTROL_POINT,
  REQUEST_CREATE_CONTROL_POINT_FAILURE,
  REQUEST_DELETE_CONTROL_POINT,
  RESPONSE_DELETE_CONTROL_POINT,
  REQUEST_DELETE_CONTROL_POINT_FAILURE,
  ON_SELECT_CONTROL_POINT,
  ON_UNSELECT_CONTROL_POINT,
} from "../actions/controlPointActions";

import { RESPONSE_CREATE_ROUTE_CONTROL_POINT, RESPONSE_DELETE_ROUTE_CONTROL_POINT } from "../actions/routeControlPointActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  controlPointsDataState: queriesStates.NOT_REQUESTED,
  createControlPointDataState: queriesStates.NOT_REQUESTED,
  deleteControlPointDataState: queriesStates.NOT_REQUESTED,
  selectedControlPointId: null,
  controlPoints: [],
  errors: [],
};

const controlPointsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CONTROL_POINTS: {
      return Object.assign({}, state, {
        controlPointsDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_CONTROL_POINTS: {
      return Object.assign({}, state, {
        controlPointsDataState: queriesStates.READY,
        controlPoints: action.data.controlPoints,
      });
    }
    case REQUEST_CONTROL_POINTS_FAILURE: {
      return Object.assign({}, state, {
        controlPointsDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_CREATE_CONTROL_POINT: {
      return Object.assign({}, state, {
        createControlPointDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_CREATE_CONTROL_POINT: {
      return Object.assign({}, state, {
        createControlPointDataState: queriesStates.READY,
        controlPoints: state.controlPoints.concat(action.data),
      });
    }
    case REQUEST_CREATE_CONTROL_POINT_FAILURE: {
      return Object.assign({}, state, {
        createRouteDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_DELETE_CONTROL_POINT: {
      return Object.assign({}, state, {
        deleteControlPointDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_DELETE_CONTROL_POINT: {
      return Object.assign({}, state, {
        deleteControlPointDataState: queriesStates.READY,
        controlPoints: state.controlPoints.filter((x) => {
          return x.id !== action.data.id;
        }),
      });
    }
    case REQUEST_DELETE_CONTROL_POINT_FAILURE: {
      return Object.assign({}, state, {
        deleteControlPointDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case RESPONSE_CREATE_ROUTE_CONTROL_POINT: {
      return Object.assign({}, state, {
        controlPoints: state.controlPoints.map((controlPoint) => {
          if (controlPoint.id === action.data.controlPoint.id) {
            controlPoint.routes = controlPoint.routes.concat({
              id: action.data.route.id,
              title: action.data.route.title,
            });
          }

          return controlPoint;
        }),
      });
    }

    case RESPONSE_DELETE_ROUTE_CONTROL_POINT: {
      return Object.assign({}, state, {
        controlPoints: state.controlPoints.map((controlPoint) => {
          if (controlPoint.id === action.data.controlPoint.id) {
            controlPoint.routes = controlPoint.routes.filter((x) => {
              return x.id !== action.data.route.id;
            });
          }

          return controlPoint;
        }),
      });
    }

    case ON_SELECT_CONTROL_POINT: {
      return Object.assign({}, state, {
        selectedControlPointId: action.data,
      });
    }

    case ON_UNSELECT_CONTROL_POINT: {
      return Object.assign({}, state, {
        selectedControlPointId: null,
      });
    }

    default:
      return state;
  }
};

export default controlPointsReducer;
